<template>
  <div class="position-absolute product-card-207-keywords">
    <span class="badge badge-secondary product-card-207-keyword-item m-1" v-for="item in product.keywords">{{
        item.keyword
      }}</span>
  </div>
  <m-card207
      :image="product.thumbnail"
      :alt="product.name"
      class="product-card-207 "
  >
    <template #p-1>
      <p class="p-0 m-0">{{ contentSlicer(product.name, 55) }}</p>
    </template>
    <template #p-2>
      <div class=""></div>
    </template>

    <template #p-3>
      <m-product-price300 class="text-center mb-3 product-card-312-price" :product="product"/>

      <m-a class="d-flex justify-content-center" :href="{ name: 'Product', params: { name: product.raw_link } }">
        <div class="card207-icon btn radius-class bg-danger p-1 font-weight-bold w-75 text-white"
             v-t="`product.show_button`">
        </div>
      </m-a>
    </template>
    <template #p-4>
      <div v-for="feature in product.feature_product">
        <div class="col-12" v-if="feature.feature_attribute.image != null">
          <m-img :src="feature.feature_attribute.image" class="img-fluid img-color-wrapper-207"/>

        </div>

      </div>
    </template>


  </m-card207>


</template>


<script>
import {shoppingCartFunctions} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";
import mCard207 from "../../Cards/Card207";
import mA from "../../Tags/A";
import mProductCardQuantityManager1 from "../../Product/QuantityManager/Card/ProductCardQuantityManager1";
import mProductPrice300 from "../../Product/ProductPrice300";
import mProductOffer1 from "../../Product/ProductOffer/ProductOffer1";
import {OfferProps} from "../ProductOffer/ProductOfferProps";
import {
  findFeatureWithSelectedName,
} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import {contentSlicer} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ContentFunctions";
import MImg from "../../Tags/Img.vue";

export default {
  name: "ProductCard207",
  components: {
    MImg,
    mCard207,
    mA,
    mProductCardQuantityManager1,
    mProductPrice300,
    mProductOffer1,
  },

  props: {
    product: {},
    showKeywords: {
      default: false
    },
    ...OfferProps,
  },
  methods: {
    contentSlicer,
    ...shoppingCartFunctions,
    findFeatureWithSelectedName,

  },
};
</script>

<style scoped>
.card207-icon {
  width: 36px;
  height: 32px;
  object-fit: cover;
  border-radius: 7px;
}

.product-card-207-keywords {
  z-index: 2;
}

.img-color-wrapper-207{
  height: 10px;
  border: 1px solid #acacac;
  border-radius: 10px;

}
</style>
